import type {
  Change,
  ChangesByEmployee,
  CustomFieldValue,
} from 'modules/employees/pages/EditInBulk/types'

interface _Employee {
  employee_id: number
}

interface CustomFields {
  custom_fields: Record<string, CustomFieldValue>
}

/**
 * @typedef FlatChangeForEmployee
 * @type {object}
 * @property {number} employee_id - employee ID
 * @property {number} location_id - new location for the employee
 * ... and the rest of the Changes properties
 */
type FlatChangeForEmployee = (_Employee & Change) | CustomFields

interface ChangesByEmployeeBackend {
  changes: FlatChangeForEmployee[]
}

const changesByEmployeeToBackend = (changes: ChangesByEmployee): ChangesByEmployeeBackend => {
  const flatedChanges: FlatChangeForEmployee[] = []
  changes.forEach((bulkChange, employeeId) => {
    const {
      employee_group_id,
      legal_entity_id,
      location_id,
      manager_id,
      permission_group_id,
      regular_access_starts_on,
      teams_ids,
      timeoff_manager_id,
      timeoff_policy_id,
      ...customFields
    } = bulkChange

    flatedChanges.push({
      employee_id: employeeId,
      custom_fields: customFields,
      ...(!!employee_group_id && { employee_group_id }),
      ...(!!legal_entity_id && { legal_entity_id }),
      ...(!!location_id && { location_id }),
      ...(!!manager_id && { manager_id }),
      ...(!!permission_group_id && { permission_group_id }),
      ...(!!regular_access_starts_on && { regular_access_starts_on }),
      ...(!!teams_ids && { teams_ids }),
      ...(!!timeoff_manager_id && { timeoff_manager_id }),
      ...(!!timeoff_policy_id && { timeoff_policy_id }),
    })
  })
  return {
    changes: flatedChanges,
  }
}

export default changesByEmployeeToBackend
